export default __webpack_public_path__ + "static/media/sand-clock.31d6cfe0.svg";